import { useEffect, useState } from 'react'
import '../WhatPeopleSay/PeopleSay.scss'
import { IoStarSharp } from "react-icons/io5"
import { FaAnglesRight, FaAnglesLeft } from "react-icons/fa6";
import Feedback from '../../FeedbackForm/Feedback';
import axios from 'axios'
import { getFeedbackurl } from '../../Services/BackendUrl'

const PeopleSay = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showFeedback, setShowFeedback] = useState(false);
  const feedback = 3;
  const arrayKleur = ["#b15928", "#6a3d9a", "#ff7f00", "#e31a1c", "#33a02c", "#1f78b4", "#a6cee3", "#b2df8a", "#fb9a99", "#fdbf6f"];

  const fetchFeedback = async () =>{
    try{
      const response = await axios.get(getFeedbackurl)
      setFeedbacks(response.data.feedbacks)
    }
    catch(error){
      console.error("Error fetch feedbacks:",error);
    }
  }

useEffect(()=>{
  fetchFeedback()
},[])


  const handleNext = () => {
    if (currentIndex + feedback < feedbacks.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const visibleFeedbacks = feedbacks.slice(currentIndex, currentIndex + feedback);

   const openFeedback = () => {
    setShowFeedback(true);
  };

  const closeFeedback = () => {
    setShowFeedback(false);
  };

  return (
    <div className='what-people-say-main-container'>
      <div className='header-portion'>
       <div className="people-say-heading"><span style={{ color: 'gray' }}>What</span> People Say</div>
        <h3 className='feedback-head' onClick={openFeedback}>GIVE YOUR FEEDBACK</h3>
         <Feedback showModal={showFeedback} handleClose={closeFeedback} />
      </div>

      <div className='feedback-container'>
        {visibleFeedbacks.map((person, index) => (
          <div className='feedback-box' key={person.id|| index}>
            <div style={{ padding: '50px 50px 0px', display:'flex', flexDirection:'column', gap:"25px" }}>
              <div className='stars' style={{ display: 'flex', gap: '5px' }}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <IoStarSharp
                    key={i}
                    size={30}
                    style={{ color: i < person.starRating ? 'orange' : '#555' }}
                  />
                ))}
              </div>
              <p style={{
    color: 'white',
    maxHeight: '225px',       
    overflow: 'hidden',       
    display: '-webkit-box',   
    WebkitLineClamp: 10,      
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word', 
    margin: 0,
  }}>{person.message}</p>
            </div>
            <div className='feedback-profile-data'
            style={{ borderTop: '1px solid #555', paddingTop: '10px' }}>
            <div style={{ display: 'flex', padding:'20px 40px 30px', gap:'20px' }}>
              <div>
              <div style={{backgroundColor:arrayKleur[index % arrayKleur.length], padding:'10px 15px', borderRadius:'50%', textTransform:'uppercase',fontFamily:'monospace'}}>{person.fullName[0]}</div>
              </div>
              <div style={{ color: 'white', display:'flex', flexDirection:'column', alignContent:"center" }}>
                <div style={{letterSpacing:'1px'}}>{person.fullName}</div>
                <p style={{fontFamily:'LeagueSpartan', fontSize:'0.7rem'}}>{person.profession}</p>
              </div>
            </div>
            </div>
          </div>
        ))}
      </div>

      {feedbacks.length > feedback && (
        <div className="feedback-btn" style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            className="view-more-button"
            onClick={handlePrev}
            disabled={currentIndex === 0}
            style={{ marginRight: '10px', opacity: currentIndex === 0 ? 0.5 : 1, background:'none', color:'white',border:'none' }}
>
            <FaAnglesLeft size={30} />
          </button>
          <button
            className="view-more-button"
            onClick={handleNext}
            disabled={currentIndex + feedback >= feedbacks.length}
            style={{ opacity: currentIndex + feedback >= feedbacks.length ? 0.5 : 1, background:'none', color:'white', border:'none' }}
          >
           <FaAnglesRight size={30}/>
          </button>
        </div>
      )}
    </div>
  )
}

export default PeopleSay
